import { render, staticRenderFns } from "./MIGS.vue?vue&type=template&id=3f6f33d7&scoped=true&"
import script from "./MIGS.vue?vue&type=script&lang=ts&"
export * from "./MIGS.vue?vue&type=script&lang=ts&"
import style0 from "./MIGS.vue?vue&type=style&index=0&id=3f6f33d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f33d7",
  null
  
)

export default component.exports